import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable, OnDestroy } from '@angular/core';
import {
  GlobalMessageService,
  GlobalMessageType,
  InterceptorUtil,
  LoggerService,
  OCC_USER_ID_ANONYMOUS,
  OccEndpointsService,
  USE_CLIENT_TOKEN,
  UserIdService
} from '@spartacus/core';
import { Subscription } from 'rxjs';
import { getHttpErrorMessage } from '../../../util/standardize-http-error';
import { WorkWithUs } from './custom-work-with-us.model';

@Injectable({
  providedIn: 'root'
})
export class CustomWorkWithUsService implements OnDestroy {
  protected logger = inject(LoggerService);
  protected subscriptions: Subscription = new Subscription();
  userId: string = '';

  constructor(
    protected userIdService: UserIdService,
    protected occEndpoints: OccEndpointsService,
    protected globalMessageService: GlobalMessageService,
    protected http: HttpClient
  ) {
    this.userIdService
      .takeUserId()
      .subscribe((userID) => (this.userId = userID))
      .unsubscribe();
  }

  subscribeRequest(data: WorkWithUs, form: any): void {
    const url = this.occEndpoints.buildUrl('workWithUs', { urlParams: { userId: this.userId } });
    let headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    if (this.userId === OCC_USER_ID_ANONYMOUS) {
      headers = InterceptorUtil.createHeader(USE_CLIENT_TOKEN, true, headers);
    }
    this.subscriptions.add(
      this.http.post<any>(url, { ...data }, { headers }).subscribe({
        next: (data) => {
          this.showGlobalMessage('forms.workWithUs.success', GlobalMessageType.MSG_TYPE_CONFIRMATION);
          form.reset();
        },
        error: (error) => {
          const httpErrorMessage = getHttpErrorMessage(error, this.logger);
          this.globalMessageService.add(httpErrorMessage, GlobalMessageType.MSG_TYPE_ERROR);
        }
      })
    );
  }

  protected showGlobalMessage(messageKey: string, messageType: GlobalMessageType): void {
    this.globalMessageService.add({ key: messageKey }, messageType);
  }

  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }
}
